import { timezoneLayer } from '../common/template';
import L10N from '../common/l10n';
import { getLanguage } from '../common/util';
import type EventEmitter from '../common/eventEmitter';
import type { ITimezoneConfig } from '../../interface/ITimezone';

class TimezoneLayer {
  $element!: HTMLElement;

  $dim!: HTMLElement;

  $contentWrap!: HTMLElement;

  $btnReset!: HTMLButtonElement;

  $btnClose!: HTMLButtonElement;

  config!: ITimezoneConfig;

  emitter!: EventEmitter;

  #language: string = getLanguage();

  #isOpen: boolean = false;

  constructor(config: ITimezoneConfig, emitter: EventEmitter) {
    if(!config) {
      console.error('config 를 확인해주세요.', config, parent);
      return;
    }

    this.config = config;
    this.emitter = emitter;
    this.init();
  }

  init() {
    this.initElement();
    this.initDimElement();
    this.initBtnResetElement();
    this.initBtnCloseElement();
  }

  initDimElement() {
    this.$dim = document.createElement('div');
    this.$dim.classList.add('ncui-timezone-dim');
    this.$element?.querySelector('.ncui-timezone-layer')?.append(this.$dim);
  }

  initBtnResetElement() {
    this.$btnReset = document.createElement('button');
    this.$btnReset.type = 'button';
    this.$btnReset.innerText = L10N?.[this.#language]?.['btnReset'] || L10N?.['en']?.['btnReset'];
    this.$btnReset.classList.add('ncui-timezone-btn-reset');
    this.$element?.querySelector('.ncui-timezone-btn-wrap')?.append(this.$btnReset);
  }

  initBtnCloseElement() {
    this.$btnClose = document.createElement('button');
    this.$btnClose.type = 'button';
    this.$btnClose.innerText = L10N?.[this.#language]?.['btnClose'] || L10N?.['en']?.['btnClose'];
    this.$btnClose.classList.add('ncui-timezone-btn-close');
    this.$element?.querySelector('.ncui-timezone-btn-wrap')?.append(this.$btnClose);
  }

  initElement() {
    const templ = timezoneLayer();
    this.$element = document.createElement('div');
    this.$element.classList.add('ncui-timezone-layer-wrap');
    this.$element?.insertAdjacentHTML('beforeend', templ);
    this.$contentWrap = this.$element.querySelector('.ncui-timezone-content-wrap')!;
  }

  open() {
    if(this.#isOpen) return;

    const { openCallback } = this.config || {};

    document.body.style.overflow = 'hidden';
    this.$element.classList.add('active');
    this.emitter?.emit('TOGGLE_OPEN_LAYER', true);
    this.addEvent();
    typeof openCallback === 'function' && openCallback();
    this.#isOpen = true;
  }

  close() {
    if(!this.#isOpen) return;

    const { closeCallback } = this.config || {};

    document.body.style.overflow = 'inherit';
    this.$element.classList.remove('active');
    this.emitter?.emit('TOGGLE_OPEN_LAYER', false);
    this.removeEvent();
    typeof closeCallback === 'function' && closeCallback();
    this.#isOpen = false;
  }

  dimClickCallback = (e: MouseEvent) => {
    this.close();
  }

  resetClickCallback = (e: MouseEvent) => {
    this.emitter?.emit('CHANGE_CURRENT_TIME');
  };

  addEvent() {
    this.$dim?.addEventListener('click', this.dimClickCallback);
    this.$btnClose?.addEventListener('click', this.dimClickCallback);
    this.$btnReset?.addEventListener('click', this.resetClickCallback);
  }

  removeEvent() {
    this.$dim?.removeEventListener('click', this.dimClickCallback);
    this.$btnClose?.removeEventListener('click', this.dimClickCallback);
    this.$btnReset?.removeEventListener('click', this.resetClickCallback);
  }

  get element() {
    return this.$element;
  }

  get contentElement() {
    return this.$contentWrap;
  }

  get isOpen() {
    return this.#isOpen;
  }
}

export default TimezoneLayer;